import { SectionHeading, Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/api";

const VALUES = [
  "Transparency",
  "Customer Assistance",
  "Location-Focused Opportunities",
  "Clear Property Information",
  "Professional Service",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <div className="relative">
              <div className="absolute -left-4 -top-4 h-full w-full rounded-xl border-2 border-gold/40" aria-hidden="true" />
              <img
                src={IMAGES.team}
                alt="Property advisor assisting a customer with plot details"
                loading="lazy"
                className="relative aspect-[4/3] w-full rounded-xl object-cover"
              />
            </div>
          </Reveal>
          <div>
            <SectionHeading
              chapter="04"
              eyebrow="Who We Are"
              title="About Exserviceman Property Services"
            />
            <Reveal delay={0.15}>
              <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
                Exserviceman Property Services is focused on helping individuals and investors explore land
                opportunities around Nagpur. We showcase residential and commercial plots selected with
                location, connectivity, and long-term potential in mind.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <div className="mt-8 flex flex-wrap gap-3">
                {VALUES.map((v) => (
                  <span
                    key={v}
                    className="rounded-sm border border-navy/15 bg-navy-50 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-navy"
                  >
                    {v}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
